import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

/** Same px value as start-page `isDesktopScreen` (layout + user guide). Below ≈ tablet / iPad widths. */
export const DESKTOP_VIEWPORT_MIN_WIDTH_PX = 1194;

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  constructor(private platform: Platform) {}

  protected MOBILE_DEVICE_WIDTH = 768;

  public isMobile(): boolean {
    return this.platform.IOS || this.platform.ANDROID;
  }

  public isSmallMobileDevice(): boolean {
    const deviceWidth = window.innerWidth;
    return this.isMobile() && deviceWidth < this.MOBILE_DEVICE_WIDTH;
  }

  /** Width at or above the start-page “desktop” layout (excludes typical iPad / tablet widths). */
  public isDesktopViewportWidth(): boolean {
    const w = window.visualViewport?.width ?? window.innerWidth;
    return w >= DESKTOP_VIEWPORT_MIN_WIDTH_PX;
  }

  /** User-guide spotlight / Help menu entry: desktop browser only, not phone/tablet/iPad-sized viewports. */
  public isUserGuideSpotlightSupported(): boolean {
    return !this.isMobile() && this.isDesktopViewportWidth();
  }
}
